import React, { Component } from "react";
import { CgImage } from "react-icons/cg";
import { FiChevronDown, FiChevronLeft } from "react-icons/fi";
import { HiOutlineArrowsExpand } from "react-icons/hi";
import { IoTrashBinOutline } from "react-icons/io5";
import Lightbox from "react-image-lightbox";
import { Modal, ModalBody } from "reactstrap";
import Empty from "../../../base/features/blocks/Empty";
import Spinner from "../../../base/features/micro/Spinner";
import CustomProductDetail from "./blocks/CustomProductDetail";
import UploadImage from "./blocks/UploadImage";
import { productCategories, productTerms } from "./services";
import ClickNHold from "react-click-n-hold";
import CategoriesModal from "../../blocks/CategoriesModal";
import PreparationTime from "./blocks/PreparationTime";
import SimpleLabel from "../../../base/features/micro/SimpleLabel";
import { getGityShopCategoriesService } from "../products/services";
import { BiSearch } from "react-icons/bi";
import { MdClose } from "react-icons/md";
import { Link } from "react-router-dom";

class ProductDetailPart1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryModal: false,
      customCategoryModal: false,
      termsModal: false,
      selectedCategory: this.props.category ? this.props.category : null,
      categories: [],
      imageModal: false,
      selectedImage: {},
      customProduct:
        window.location.pathname.split("/")[3] === "cp" ? true : false,
      shopUid: window.location.pathname.split("/")[2],
      gityCategories: [],
      shopCategoriesSearchKey: "",
    };
  }
  componentDidMount() {
    this.getCategories();
    this.getGityShopCategories();
  }
  componentDidUpdate() {
    if (this.state.selectedCategory === null && this.props.category) {
      this.setState({ selectedCategory: this.props.category });
    }
  }
  getTerms() {
    productTerms().then((items) => {
      items && this.setState({ terms: items });
    });
  }
  getCategories() {
    productCategories().then((items) => {
      items && this.setState({ categories: items.results });
    });
  }
  imageRemove() {
    var new_medias = this.props.images;
    new_medias.splice(this.state.imageIndex, 1);
    this.props.imagesChange(new_medias);
    if (
      this.state.selectedImage.uid === this.props.cover.uid &&
      new_medias.length > 0
    ) {
      this.props.coverChange(new_medias[0]);
    }
    this.setState({ imageModal: false });
  }
  getGityShopCategories() {
    getGityShopCategoriesService(this.state.shopUid).then((items) => {
      this.setState({ gityCategories: items });
    });
  }
  render() {
    return (
      <div style={{ marginBottom: "30px" }}>
        {this.state.customProduct && <CustomProductDetail />}
        <div className="row mx-0">
          <div className="col-4 px-0">
            <UploadImage
              images={this.props.images}
              updateImages={(images) => {
                this.props.imagesChange(images);
              }}
            />
          </div>
          {this.props.images.length > 0 &&
            this.props.images.map((image, i) => (
              <div
                className={
                  "col-4 p-0 position-relative text-center rounded14 " +
                  (this.props.cover &&
                    image.uid === this.props.cover.uid &&
                    "border-main")
                }
                style={{ height: "100px" }}
              >
                <img
                  alt="camera"
                  className="h-100 w-100 rounded14 img-cover "
                  src={image.file}
                  onClick={() =>
                    this.setState({
                      selectedImage: image,
                      imageModal: true,
                      imageIndex: i,
                    })
                  }
                />
              </div>
            ))}
        </div>
        <div className="row mx-0">
          <div className="col-12 px-0 mt-4 position-relative">
            <input
              value={this.props.title}
              onChange={(e) => this.props.titleChange(e.target.value)}
              className="form-control p-3 rounded14"
              placeholder="نام محصول"
            />
            {this.props.title && <SimpleLabel text="نام محصول" />}
          </div>
          <div className="col-12 px-0 mt-4 position-relative">
            <textarea
              value={this.props.des}
              rows="4"
              onChange={(e) => this.props.desChange(e.target.value)}
              className="form-control p-3 rounded14"
              placeholder="توضیحات محصول"
            />
            {this.props.des && <SimpleLabel text="توضیحات محصول" />}
          </div>
          {this.state.gityCategories.shop_categories?.length === 0 && (
            <div
              className="col-12 mt-4 p-3 border rounded14"
              onClick={() => this.setState({ categoryModal: true })}
            >
              <div className="row mx-0">
                <div className="col fw-bold px-0">
                  {this.props.category
                    ? this.props.category.title
                    : "انتخاب دسته بندی"}
                </div>
                <div className="col-auto px-0 align-self-center">
                  <FiChevronDown size={20} />
                </div>
              </div>
            </div>
          )}
          <div
            className="col-12 mt-4 p-3 border rounded14"
            onClick={() => this.setState({ customCategoryModal: true })}
          >
            <div className="row mx-0">
              <div className="col fw-bold px-0">
                {this.props?.shop_category?.name || "انتخاب دسته بندی اختصاصی"}
              </div>
              <div className="col-auto px-0 align-self-center">
                <FiChevronDown size={20} />
              </div>
            </div>
          </div>
          <div
            className="col-12 mt-4 p-3 border rounded14"
            onClick={() => this.setState({ timeModal: true })}
          >
            <div className="row mx-0">
              <div className="col fw-bold px-0">
                {this.props.time === null
                  ? "محصول نیاز به زمان آماده سازی ندارد"
                  : this.props.time === 0
                  ? "محصول آماده است"
                  : `${
                      (this.props.time / 1440).toFixed(0) !== 0
                        ? (this.props.time / 1440).toFixed(0) + " روز"
                        : ""
                    }  ${
                      ((this.props.time % 1440) / 60).toFixed(0) !== 0
                        ? ((this.props.time % 1440) / 60).toFixed(0) + " ساعت"
                        : ""
                    }  ${
                      (this.props.time % 1440) % 60 !== 0
                        ? ((this.props.time % 1440) % 60) + " دقیقه"
                        : ""
                    } `}
              </div>
              <div className="col-auto px-0 align-self-center">
                <FiChevronDown size={20} />
              </div>
            </div>
          </div>
          <div className="col-12 mt-4 p-3 bg-light-gray rounded14 fw-bold fs-7">
            <span>برای ثبت و یا ویرایش محصول و اطلاعات آن به </span>
            <span
              className="color-main"
              onClick={() => {
                this.setState({ termsModal: true });
                this.getTerms();
              }}
            >
              قوانین{" "}
            </span>
            <span>توجه داشته باشید</span>
          </div>
        </div>
        <CategoriesModal
          categoryModal={this.state.categoryModal}
          changeModal={(e) => this.setState({ categoryModal: e })}
          category={this.props.category}
          categoryChange={(e) => this.props.categoryChange(e)}
        />
        {this.state.timeModal && (
          <PreparationTime
            timeModal={this.state.timeModal}
            changeModal={(e) => this.setState({ timeModal: e })}
            time={this.props.time}
            timeChange={(e) => this.props.timeChange(e)}
          />
        )}
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.state.termsModal}
          toggle={() => this.setState({ termsModal: false })}
        >
          <ModalBody className="row mx-0 p-4">
            {this.state.terms ? (
              <div className="col-12 px-0 py-2">
                {this.state.terms.length === 0 ? (
                  <Empty text={"موردی یافت نشد"} />
                ) : (
                  this.state.terms.map((term, t) => (
                    <div>
                      <h2 className="fw-bold fs-4">{term.title}</h2>
                      <p
                        className="fw-bold text-muted"
                        style={{ whiteSpace: "pre-wrap", lineHeight: "1.7em" }}
                      >
                        {term.des}
                      </p>
                    </div>
                  ))
                )}
              </div>
            ) : (
              <Spinner />
            )}
            <button
              onClick={() => this.setState({ termsModal: false })}
              className="btn rounded28 py-2 w-100 fw-bold bg-color-main text-center text-white"
            >
              متوجه شدم
            </button>
          </ModalBody>
        </Modal>
        {this.state.imageModal && this.state.selectedImage && (
          <Modal
            dir="rtl"
            zIndex="9999999"
            className="m-0"
            contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
            isOpen={this.state.imageModal}
            toggle={() => this.setState({ imageModal: false })}
          >
            <ModalBody className="row mx-0 p-4">
              {this.state.selectedImage.uid !== this.props.cover.uid && (
                <div
                  className="row mx-0 p-3 border rounded14"
                  onClick={() => {
                    this.setState({
                      imageModal: false,
                    });
                    this.props.coverChange(this.state.selectedImage);
                  }}
                >
                  <div className="col-auto px-1 align-self-center">
                    <CgImage size={20} />
                  </div>
                  <div className="col px-2">
                    <p className="mb-0 fs-5 fw-bold">تنظیم به عنوان کاور</p>
                  </div>
                  <div className="col-auto px-1 align-self-center">
                    <FiChevronLeft size={24} />
                  </div>
                </div>
              )}
              <div
                className="row mx-0 p-3 border rounded14 mt-3"
                onClick={() =>
                  this.setState({ imageModal: false, lightbox: true })
                }
              >
                <div className="col-auto px-1 align-self-center">
                  <HiOutlineArrowsExpand size={20} />
                </div>
                <div className="col px-2">
                  <p className="mb-0 fs-5 fw-bolder">نمایش تمام صفحه</p>
                </div>
                <div className="col-auto px-1 align-self-center">
                  <FiChevronLeft size={24} />
                </div>
              </div>
              <ClickNHold
                className="px-0"
                time={2}
                onClickNHold={() => this.imageRemove()}
              >
                <div className="row mx-0 p-3 border border-danger text-danger rounded14 mt-3">
                  <div className="col-auto px-1 align-self-center">
                    <IoTrashBinOutline size={20} />
                  </div>
                  <div className="col px-2">
                    <p className="mb-0 fs-6 fw-bolder">
                      برای حذف عکس نگه دارید
                    </p>
                  </div>
                  <div className="col-auto px-1 align-self-center">
                    <FiChevronLeft size={24} />
                  </div>
                </div>
              </ClickNHold>
            </ModalBody>
          </Modal>
        )}
        {this.state.lightbox && this.state.selectedImage && (
          <Lightbox
            mainSrc={this.state.selectedImage.file}
            onCloseRequest={() => this.setState({ lightbox: false })}
          />
        )}
        {this.state.customCategoryModal && (
          <Modal
            dir="rtl"
            zIndex="9999999"
            className="m-0"
            contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
            isOpen={this.state.customCategoryModal}
            toggle={() => this.setState({ customCategoryModal: false })}
          >
            <ModalBody
              className="row mx-0 p-4"
              style={{ position: "relative" }}
            >
              <div
                className="col-12 px-0 pt-4 position-sticky bg-white"
                style={{ top: 0 }}
              >
                <div className="row mx-0 p-3 rounded14 border mb-4">
                  <div className="col-auto px-0">
                    <BiSearch size={22} className="text-secondary" />
                  </div>
                  <div className="col px-2">
                    <input
                      className="w-100 h-100 p-0 border-0 fw-bold border-0"
                      placeholder="جستجو ..."
                      value={this.state.shopCategoriesSearchKey}
                      onChange={(e) =>
                        this.setState({
                          shopCategoriesSearchKey: e.target.value,
                        })
                      }
                    />
                  </div>
                  {this.state.key && (
                    <div className="col-auto px-0">
                      <MdClose
                        size={26}
                        onClick={() =>
                          this.setState({ shopCategoriesSearchKey: "" })
                        }
                      />
                    </div>
                  )}
                </div>
                <Link
                  to={{
                    pathname: `/dashboard/${this.state.shopUid}/new-shop-category`,
                  }}
                >
                  <div
                    className="color-main text-center w-100 mb-4"
                    style={{ fontSize: "13px" }}
                  >
                    افزودن دسته بندی جدید
                  </div>
                </Link>
              </div>
              <div className="row justify-content-between mt-2">
                {this.state.gityCategories?.shop_categories?.length > 0 ? (
                  this.state.gityCategories?.shop_categories
                    ?.filter((item) =>
                      item?.name.includes(this.state.shopCategoriesSearchKey)
                    )
                    ?.map((item) => (
                      <div
                        className={`border ${
                          this.props.shop_category?.uid === item?.uid
                            ? "border-main color-main"
                            : "border-secondary"
                        } rounded14 mb-3 text-center py-2 d-flex align-items-center justify-content-center`}
                        style={{
                          width: "31%",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          this.props.shopCategoryChange(item);
                          this.setState({ customCategoryModal: false });
                        }}
                      >
                        {item?.name}
                      </div>
                    ))
                ) : (
                  <Empty text="دسته بندی موجود نمی باشد" />
                )}
              </div>
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}

export default ProductDetailPart1;
